const util = {
    //跳转主域名
    jumpLink: function(){
        if(window.location.href.indexOf('zgapp') > 0){
            let newLink = window.location.href.replace('zgapp.gxnews.com.cn/h5', 'byte.gxnews.com.cn/zg');
            window.location.href = newLink;
        }      
    }
}
export default util